import React from 'react';
import './PolicyPages.css';

const Terms = () => {
  return (
    <div className="policy-page">
      <div className="container">
        <div className="policy-header">
          <h1>Terms & Conditions</h1>
          <p>Last updated: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="policy-content">
          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>By accessing and using VisionCare Optics website, you agree to be bound by these Terms & Conditions. If you do not agree with any part of these terms, please do not use our website.</p>
          </section>

          <section>
            <h2>2. Products & Pricing</h2>
            <p>All products displayed on our website are subject to availability. We reserve the right to discontinue any product at any time. Prices are subject to change without notice. All prices are in Indian Rupees (INR).</p>
          </section>

          <section>
            <h2>3. Orders & Payment</h2>
            <p>We accept payments via credit/debit cards, net banking, UPI, and cash on delivery (COD). All orders are subject to acceptance and availability. We reserve the right to refuse or cancel any order.</p>
          </section>

          <section>
            <h2>4. Prescription Verification</h2>
            <p>For prescription eyewear, you must provide a valid prescription from a licensed optometrist. We reserve the right to verify prescription details before processing your order.</p>
          </section>

          <section>
            <h2>5. User Accounts</h2>
            <p>You are responsible for maintaining the confidentiality of your account credentials. You agree to accept responsibility for all activities that occur under your account.</p>
          </section>

          <section>
            <h2>6. Intellectual Property</h2>
            <p>All content on this website, including images, logos, text, and graphics, is the property of VisionCare Optics and is protected by copyright laws.</p>
          </section>

          <section>
            <h2>7. Limitation of Liability</h2>
            <p>VisionCare Optics shall not be liable for any indirect, incidental, or consequential damages arising from the use of our products or website.</p>
          </section>

          <section>
            <h2>8. Governing Law</h2>
            <p>These terms shall be governed by and construed in accordance with the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in Chennai, Tamil Nadu.</p>
          </section>

          <section>
            <h2>9. Contact Information</h2>
            <p>For any questions regarding these Terms & Conditions, please contact us at:<br />
            Email: kadharvco@gmail.com<br />
            Phone: +91 94436 53501</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;